import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Router } from 'react-router';
import { applicationHistory } from '../common/application-history';
import SnapfishHeader from '../header/components/snapfish-header';
import SnapfishNavigation from '../snapfish/components/snapfish-navigation';
import SnapfishAlbumView from '../snapfish/components/snapfish-album-view';
import SnapfishAlbumItemView from '../snapfish/components/snapfish-album-item-view';
import SnapfishUploadView from '../snapfish/components/snapfish-upload-view';
import { SnapfishHeaderNavigation } from '../snapfish/components/snapfish-header-navigation';
import { setAlbumsViewMode } from '../settings/actions/application-actions';
import UploadController from '../uploadController/components/uploadController-container';

import {
	requestSnapfishCollections,
	requestSnapfishPhotoElements,
	clearPhotoElements,
	clearSelection,
	setCurrentAlbumId,
	selectItem,
	deselectItem
} from '../snapfish/actions/snapfish-actions';

import '../album-view/style/album.scss';
import '../common/style/common.scss';

class SnapfishRoute extends PureComponent {
	constructor(props) {
		super(props);



		this.loadAdditionalAlbums = this.loadAdditionalAlbums.bind(this);
		this.selectCustomCollection = this.selectCustomCollection.bind(this);
		this.loadAdditionalAlbumItems = this.loadAdditionalAlbumItems.bind(this);
		this.backButtonClick = this.backButtonClick.bind(this);
		this.photoElementClick = this.photoElementClick.bind(this);
		this.clearSelection = this.clearSelection.bind(this);
		this.amISelected = this.amISelected.bind(this);
	}

	componentDidUpdate(prevProps) {

const {currentAlbumId, isCompleteAlbums, isCompleteItems} = this.props;

if(currentAlbumId === -1 && !isCompleteAlbums){
	this.loadAdditionalAlbums();
}
else if(currentAlbumId !== -1 && !isCompleteItems){

	this.loadAdditionalAlbumItems();

}


	}

	clearSelection() {
		const { clearSelection } = this.props;
		clearSelection();
	}

	loadAdditionalAlbums() {

		const { requestAlbumList, albumOffset, amIfetchingAlbums } = this.props;
		requestAlbumList(albumOffset, amIfetchingAlbums);

	}

	loadAdditionalAlbumItems() {

		const { requestPhotoElements, currentAlbumId, currentAlbumOffset, currentAlbumMax, amIfetchingItems } = this.props;

		requestPhotoElements(currentAlbumId, currentAlbumOffset, currentAlbumMax, amIfetchingItems);

	}

	selectCustomCollection(ccId) {
		const { setCurrentAlbumId } = this.props;
		setCurrentAlbumId(ccId);
	}

	backButtonClick() {
		const { clearPhotoElements } = this.props;
		clearPhotoElements();
	}

amISelected(theSet, id){



	const setArray = Array.from(theSet);
	var found = setArray.find(function(element) {
		return element.id ===id;
	  });
	  return found;
}


	photoElementClick(element) {
		const { selectItem, deselectItem, selectedItems } = this.props;


		if (this.amISelected(selectedItems, element.id)) {
			deselectItem(element);
		} else {
			selectItem(element);
		}
	}

	render() {
		return (
			<Router history={applicationHistory}>
				<div>
					<div>
						<SnapfishHeader
							{...this.props}
							clearClick={this.clearSelection}
							successCallback={this.props.successCallback}
						/>
					</div>
					<div className="default-content-layout snapfish-content-layout">
						<div className="left-nav" role="navigation">
							<SnapfishNavigation {...this.props} />
						</div>
						<div className="right-side">
							<SnapfishHeaderNavigation backClick={this.backButtonClick} isVisible={this.props.currentAlbumId !== -1} />
							<div className={this.props.viewMode === 'album' ? '' : 'hidden'}>
								<SnapfishAlbumView
									isVisible={this.props.currentAlbumId === -1}
									albums={this.props.albums}
									loadAdditionalAlbums={this.loadAdditionalAlbums}
									requestMade={this.props.amIfetchingAlbums}
									itemClick={ccId => {
										this.selectCustomCollection(ccId);
									}}
								/>
								<SnapfishAlbumItemView
									isVisible={this.props.currentAlbumId !== -1}
									albumId={this.props.currentAlbumId}
									albumItems={this.props.albumItems}
									requestMade={this.props.amIfetchingItems}
									loadAdditionalAlbumItems={this.loadAdditionalAlbumItems}
									selectItem={this.photoElementClick}
								/>
							</div>
							<div className={this.props.viewMode === 'album' ? 'hidden' : ''}>
								<SnapfishUploadView isVisible={false} />
							</div>
						</div>
					</div>
					<UploadController/>
				</div>

			</Router>
		);
	}
}

SnapfishRoute.propTypes = {
	albums: PropTypes.object,
	albumItems: PropTypes.object,
	currentAlbumId: PropTypes.number,
	requestAlbumList: PropTypes.func,
	albumOffset: PropTypes.number,
	requestPhotoElements: PropTypes.func,
	setCurrentAlbumId: PropTypes.func,
	clearPhotoElements: PropTypes.func,
	clearSelection: PropTypes.func,
	selectItem: PropTypes.func,
	deselectItem: PropTypes.func,
	selectedItems: PropTypes.object,
	currentAlbumOffset: PropTypes.number,
	currentAlbumMax: PropTypes.number,
	viewMode: PropTypes.string,
	successCallback: PropTypes.func,
	isCompleteAlbums: PropTypes.bool,
	isCompleteItems: PropTypes.bool,
	amIfetchingAlbums: PropTypes.bool,
	amIfetchingItems: PropTypes.bool,
};

const mapStateToProps = state => {
	return {
		albums: state.snapfish.snapfishCollections,
		albumOffset: state.snapfish.snapfishCollectionOffset,

		albumItems: state.snapfish.snapfishPhotoElements,
		currentAlbumCount: state.snapfish.currentAlbumCount,
		currentAlbumMax: state.snapfish.currentAlbumMax,
		currentAlbumOffset: state.snapfish.currentAlbumOffset,
		currentAlbumId: state.snapfish.currentAlbumId,
		selectedItems: state.snapfish.snapfishSelectedElements,
		viewMode: state.snapfish.viewMode,
		isCompleteAlbums: state.snapfish.isCompleteAlbums,
		isCompleteItems: state.snapfish.isCompleteItems,
		amIfetchingAlbums: state.snapfish.amIfetchingAlbums,
		amIfetchingItems: state.snapfish.amIfetchingItems
	};
};

const mapDispatchToProps = dispatch => {
	return {
		requestAlbumList: (offset = 0, amIfetchingAlbums = false ) => {
			dispatch(requestSnapfishCollections(dispatch, offset, amIfetchingAlbums));
		},
		requestPhotoElements: (ccId, offset = 0, max = 25, amIfetchingItems = false) =>
			dispatch(requestSnapfishPhotoElements(dispatch, ccId, offset, max, amIfetchingItems)),
		setAlbumsViewMode: () => dispatch(setAlbumsViewMode()),
		clearPhotoElements: () => dispatch(clearPhotoElements()),
		setCurrentAlbumId: ccId => dispatch(setCurrentAlbumId(ccId)),
		selectItem: id => dispatch(selectItem(id)),
		deselectItem: id => dispatch(deselectItem(id)),
		clearSelection: () => dispatch(clearSelection())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SnapfishRoute);



// WEBPACK FOOTER //
// ./src/routes/snapfish-route.jsx